module.exports = __webpack_public_path__ + "static/img/icon-service.16f0ae15.png";